import {Pages} from 'shared/config/model/pages';
import {AppUrls} from 'shared/config/model/urls';

import React, {useCallback, useMemo} from 'react';
import {useSearchParams} from 'react-router-dom';
import {i18n} from '@lingui/core';

import {tariffVariantAPI} from 'features/admin/api/tariffVariantAPI';
import ListPage from 'shared/ui/ListPage/ListPage';
import ListToolbar from 'shared/ui/ListToolbar/ListToolbar';
import TableToolbar from 'shared/ui/TableToolbar/TableToolbar';
import ListFiltersModal from 'shared/ui/Modal/ListFiltersModal/ListFiltersModal';
import useOpenState from 'shared/lib/hooks/useOpenState';
import {ITariffVariant} from 'entities/tariff';

import {t} from '@lingui/core/macro';

import {filterTariffVariants} from '../../lib/tariffVariantFilters';
import CreateTariffVariantsButton from './CreateTariffVariantsButton';
import TariffVariantRow from './TariffVariantRow';
import TariffVariantsFiltersForm from './TariffVariantsFiltersForm/TariffVariantsFiltersForm';


const TABLE_COLUMNS = [
    {label: 'ID', sort: 'id', key: 'id'},
    {label: 'Скидка', sort: 'discount', key: 'discount'},
    {label: 'Кол-во дней', sort: 'period', key: 'period'},
    {label: 'Тарифы', key: 'tariffs'},
    {label: '', key: 'actions'},
];

const TariffVariants: React.FC = () => {
    const [searchParams] = useSearchParams();
    const filtersModal = useOpenState();
    const {data: items, isLoading} = tariffVariantAPI.useGetTariffVariantsQuery(undefined);

    const variants = useMemo(() => {
        return (items || [])
            .filter(item => item.id !== 0)
            .sort((a, b) => a.id - b.id);
    }, [items]);

    const processedItems = useMemo(
        () => filterTariffVariants(variants, searchParams),
        [variants, searchParams],
    );
    const hasFilters = processedItems.length !== variants.length;

    const renderRow = useCallback((item: ITariffVariant) => (
        <TariffVariantRow key={item.id} item={item} />
    ), []);


    return (
        <ListPage
            documentTitle={`${t`Редактор пакетов тарифов`} | ${t`Overseer`}`}
            toolbar={(
                <ListToolbar
                    title={i18n._(Pages.ADMIN_TARIFF_VARIANTS)}
                    backUrl={AppUrls.SETTINGS}
                    createButton={<CreateTariffVariantsButton/>}
                    actions={<TableToolbar onFilter={filtersModal.open}/>}
                />
            )}
            columns={TABLE_COLUMNS}
            items={processedItems}
            rowFactory={renderRow}
            isLoading={isLoading}
            aria-rowcount={items?.length}
            emptyStateComponent={hasFilters ? t`Ничего не найдено` : undefined}
        >
            <ListFiltersModal
                open={filtersModal.isOpen}
                handleClose={filtersModal.close}
                Form={TariffVariantsFiltersForm}
            />
        </ListPage>
    );
};

export default React.memo(TariffVariants);
